function remanager(params) {
  this.key = params.key;
  this.key3 = params.key3;
  this.theme = params.theme || 'dark';
  this.captchaLoaded = false;
  window.remanagerState = this;
}

remanager.prototype.render = function(selector = '#recaptcha') {

  var that = window.remanagerState;

  if(that.captchaLoaded != true) {
      this.getScript('https://www.google.com/recaptcha/api.js?render=explicit');
      that.captchaLoaded = true;
  }

  if(typeof grecaptcha == 'undefined') {
      setTimeout(that.render, 1000, selector);
      return;
  }

  that.captchaEl = document.querySelector(selector)
  if(!that.captchaEl) return;
  that.version = 2;
  var captchaId = grecaptcha.render(that.captchaEl, {
      sitekey: that.key,
      theme: that.theme,
      'expired-callback': function() {
          renderCaptcha(container);
      }
  })

  that.captchaId = captchaId;

}

remanager.prototype.render3 = function(selector = '#recaptcha') {
  var that = window.remanagerState;


  if(that.captchaLoaded != true) {
    this.getScript('https://www.google.com/recaptcha/api.js?render='+that.key3);
    that.captchaLoaded = true;
  }

  if(typeof grecaptcha == 'undefined') {
    console.log('ssosa')
      setTimeout(that.render3, 1000, selector);
      return;
  }

  grecaptcha.ready(function() {
    grecaptcha.execute('6Ldyd7cUAAAAAKrQiPRvsArENgfiKPiUWqWDFbGP', {action: 'homepage'}).then(function(token) {
      that.response3 = token;
      that.version = 3;
    });
  });
}

remanager.prototype.reset = function() {
  if(typeof window.remanagerState.captchaId == 'undefined') return;
  grecaptcha.reset(
      window.remanagerState.captchaId
  )
}

remanager.prototype.getScript = function(source, callback) {
  var head  = document.getElementsByTagName('head')[0];
  var script  = document.createElement('script');
  script.src = source;
  head.appendChild(script);

  if(callback) callback();
}




export default remanager;

